import React, { useRef, useState } from 'react';
import { useTable, usePagination, useSortBy, useFilters, useGlobalFilter, useAsyncDebounce } from "react-table";
import { SiMicrosoftexcel } from 'react-icons/si';
import { BsPrinter } from 'react-icons/bs';
import { useReactToPrint } from 'react-to-print';
import ReactHtmlTableToExcel from 'react-html-table-to-excel';
import { CgPushChevronLeft, CgPushChevronRight } from "react-icons/cg";
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

export function CommonReactTable(props) {
    const { columns, data, filename, showFooter,pagination,search } = props;
    const {
        getTableBodyProps,
        headerGroups,
        footerGroups,
        page,
        canPreviousPage,
        canNextPage,
        preGlobalFilteredRows,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        state: { pageIndex, pageSize },
        setPageSize,
        globalFilter,
        setGlobalFilter,
        rows,
        prepareRow
    } = useTable({
        columns,
        data,

        initialState: { pageIndex: 0, pageSize: 10},

    },

        useFilters,
        useGlobalFilter,
        useSortBy,
       usePagination
        ,
    );
let navigate = useNavigate()
    const [value, setValue] = React.useState(globalFilter)
    const onChange = useAsyncDebounce(valuess => {
        setGlobalFilter(valuess)
    }, 200)
    let componentRef = useRef();
    const handleprint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: "college-data",
    });
    
    const [currentPage, setCurrentPage] = useState(1);
    function rowsCount(a) {

//    console.log("a.Footer",data)
        //const currentPageRows = rows.slice(pageIndex * pageSize, (pageIndex + 1) * pageSize);
        const rdata = data.slice(pageIndex * pageSize, (pageIndex + 1) * pageSize);
        const countSum =rdata.reduce((sum, row) => sum + row[a.Footer], 0)
       // const countSum = currentPageRows.reduce((sum, row) => sum + row.values[a.Footer], 0); // currentPageRows
        if (isNaN(countSum) === false) {
            return countSum
        }
        else {
            return ""
        }
    }
    return (
        <React.Fragment>
        {search==="false"?"":<> 
            <span>
                <input
                    value={value || ""}
                    name={`search_${Date.now()}`}
                    onChange={e => {
                        setValue(e.target.value);
                        onChange(e.target.value);
                    }}
                    placeholder="Search"
                    style={{
                        fontSize: '1.1rem',
                        border: '1',
                    }}
                />
            </span>
            &emsp;
            <ReactHtmlTableToExcel id="test-table-xls-button"
                className="pull-right btn btn-sm btn-success" table="table-to-xls"
                filename={filename} sheet="tablexls"
                buttonText={<SiMicrosoftexcel size={20} title="Excel" />} />&nbsp;
            <BsPrinter onClick={handleprint} title="Print" className=" btn btn-primary btn-sm"
                style={{ fontSize: '32px' }} />
                </>}
            <div className='table-responsive'>
                <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-2"
                    style={{ border: '1px solid lightblue', width: '100%', borderCollapse: 'collapse', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}
                    ref={componentRef} id="table-to-xls" >
                    <thead >
                        {headerGroups.map((headerGroup, index) => (
                            <tr key={index} {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column, index) => (
                                    <th key={index} {...column.getHeaderProps(column.getSortByToggleProps())} data-toggle="tooltip" animation="true" title={column?.tooltipmsg} >
                                        {column.render('Header')}
                                        <span>
                                            {column.isSorted
                                                ? column.isSortedDesc
                                                    ? ' 🔽'
                                                    : ' 🔼'
                                                : ''}
                                        </span>
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()} style={{ fontSize: "12px", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {page.map((row, index) => {
                            prepareRow(row);
                            return (
                                <tr {...row.getRowProps()} key={index}>
                                    {row.cells.map((cell, index) => {
                                        return <td key={index} {...cell.getCellProps()} style={ { overflowWrap: "break-word", whiteSpace: 'normal'} }>{cell.render("Cell")}</td>;
                                    })}
                                </tr>
                            );
                        })}
                    </tbody>
                    {showFooter === "true" ? <tfoot>
                        <tr>
                            {footerGroups[0].headers.map((column, cindex) => (
                                <td key={cindex} {...column.getFooterProps()} style={{ border: '1px solid black' }}>
                                    {column.Footer === 'Total' ? column.render('Footer') : column.Footer === column.Header && column.fclickable === true ?

                                        (<span style={{ color: "Highlight", textDecoration: "underline" }}
                                            onClick={() => {
                                                if (column.fclickable === true) {
                                                    navigate(column.path,{state:{path:column?.path}})
                                                }
                                                else {

                                                }
                                            }}> {rowsCount(column, rows, pageIndex, pageSize)}</span>) :
                                        
                                            rowsCount(column, rows, pageIndex, pageSize)
                                           }
                                </td>
                            ))}
                        </tr>
                    </tfoot> : null}

                </table>
            </div>
            {
                pagination==="false"?"":
           
            <div className="pagination mt-2">
                <button type='button' onClick={() => gotoPage(0)} disabled={!canPreviousPage}><CgPushChevronRight size={21} /></button>&emsp;
                <button type='button' onClick={() => previousPage()} disabled={!canPreviousPage}><FaChevronRight /></button>&emsp;
                <button type='button' onClick={() => nextPage()} disabled={!canNextPage}><FaChevronLeft /></button>&emsp;
                <button type='button' onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}><CgPushChevronLeft size={21} /></button>&emsp;
                <button type='button' className='mt-1'>&emsp;{currentPage} - <strong>{pageSize}</strong> of <strong>{preGlobalFilteredRows.length} </strong>  &emsp;</button>
                <select value={pageSize} onChange={e => {
                    setPageSize(Number(e.target.value)); setCurrentPage(1);
                }}>
                 <option value={rows.length}>All</option>
                 <option value={10}>10</option>
                 <option value={20}>20</option>
                    
                </select>
                Rows per page : &emsp;
            </div> }
        </React.Fragment>
    );
}
